import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCart } from "./context/CartContext";
import emailjs from "@emailjs/browser";

const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const EMAILJS_ORDER_TEMPLATE_ID = "template_7i2l5fo"; 
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

function PaymentSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { clearCart } = useCart();
  const [searchParams] = useSearchParams();
  
  const [status, setStatus] = useState("verifying"); 
  const [orderId, setOrderId] = useState("");
  const emailSentRef = useRef(false);

  useEffect(() => {
    const txnStatus = searchParams.get("txnStatus"); 
    const merchantTxnNo = searchParams.get("merchantTxnNo");
    const amount = searchParams.get("amount");

    if (merchantTxnNo) {
      setOrderId(merchantTxnNo);
    }

    // 1. Set fallback verification states
    if (txnStatus === "SUC" || !txnStatus) {
      setStatus("success");
      clearCart(); 
    } else {
      setStatus("failed");
    }

    // 2. Dispatch Email alert to admin
    if (!emailSentRef.current) {
      emailSentRef.current = true;
      
      const storedOrder = localStorage.getItem("chirayu_pending_order");
      let orderDetails = "Manual QR Code Scanner Scan Received.";
      let customerName = "Valued Customer";
      let customerPhone = "N/A";
      let customerEmail = "N/A";
      let detailedAddress = "Stored in Database Securely";
      let orderPrice = amount ? `₹${amount}` : "Processed via Scanner Layout";

      if (storedOrder) {
        try {
          const parsedOrder = JSON.parse(storedOrder);
          customerName = parsedOrder.name || customerName;
          customerPhone = parsedOrder.phone || customerPhone;
          customerEmail = parsedOrder.email || customerEmail;
          orderDetails = parsedOrder.items || orderDetails;
          orderPrice = parsedOrder.totalAmount ? `₹${parsedOrder.totalAmount}` : orderPrice;
          detailedAddress = `${parsedOrder.address || ""}, ${parsedOrder.city || ""} - ${parsedOrder.pincode || ""}`;
        } catch (e) {
          console.error("Error reading cached local data:", e);
        }
      }
      
      // Dispatch alert email to sales@chirayumedicos.com via EmailJS
      emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_ORDER_TEMPLATE_ID,
        {
          order_id: merchantTxnNo || "N/A", 
          customer_name: customerName,
          from_name: customerName,         
          customer_phone: customerPhone,
          customer_email: customerEmail,
          from_email: customerEmail,       
          order_details: orderDetails,
          total_price: orderPrice, 
          address: detailedAddress,
          payment_type: `Direct UPI QR Scanner (Manual Review)`
        },
        EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        console.log(`Admin validation alert sent to sales@chirayumedicos.com`);
        localStorage.removeItem("chirayu_pending_order"); 
      })
      .catch(err => {
        console.error("Email notification dispatch issue:", err);
        localStorage.removeItem("chirayu_pending_order"); 
      });
    }
  }, [searchParams, clearCart]);

  return (
    <div className="container" style={{ padding: "140px 20px", textAlign: "center", minHeight: "60vh" }}>
      {status === "verifying" && (
        <div>
          <div className="spinner" style={{ margin: "0 auto 20px" }}></div>
          <h2>{t("paymentStatus.verifying.title")}</h2>
          <p>{t("paymentStatus.verifying.text")}</p>
        </div>
      )}

      {status === "success" && (
        <div style={{ maxWidth: "500px", margin: "0 auto", padding: "40px 20px", background: "#fdfdfd", borderRadius: "15px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
          <div style={{ fontSize: "4rem", marginBottom: "20px" }}>✅</div>
          <h3 style={{ color: "var(--primary-color)", marginBottom: "15px" }}>Order Logged Successfully!</h3>
          <p style={{ lineHeight: "1.6", color: "#555", marginBottom: "10px" }}>
            Your tracking file parameter details have been written to our desk matrix under system index:
          </p>
          <div style={{ background: "#f1f3f5", padding: "10px", borderRadius: "8px", fontWeight: "bold", color: "#333", marginBottom: "25px", letterSpacing: "1px" }}>
            {orderId}
          </div>
          <p style={{ fontSize: "0.9rem", color: "#666", marginBottom: "25px" }}>
            Our admin team is manually reviewing the incoming bank statements. Your product delivery configurations will begin processing once verification completes.
          </p>
          <button className="btn-primary" onClick={() => navigate("/")} style={{ width: "100%" }}>
            {t("paymentStatus.success.button")}
          </button>
        </div>
      )}

      {status === "failed" && (
        <div style={{ maxWidth: "500px", margin: "0 auto", padding: "40px 20px", background: "#fdfdfd", borderRadius: "15px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)" }}>
          <div style={{ fontSize: "4rem", marginBottom: "20px" }}>❌</div>
          <h3 style={{ color: "#ff4d4d", marginBottom: "15px" }}>Submission Errant</h3>
          <p style={{ lineHeight: "1.6", color: "#555", marginBottom: "25px" }}>
            We could not map your submission credentials safely over network infrastructure hooks.
          </p>
          <button className="btn-primary" onClick={() => navigate("/checkout")} style={{ width: "100%", background: "#ff4d4d", border: "none", color: "white", padding: "12px", borderRadius: "5px", cursor: "pointer" }}>
            Return to Checkout
          </button>
        </div>
      )}
    </div>
  );
}

export default PaymentSuccess;